import React, { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../helpers/font-awesome'
import { useTheme } from '../../context/themeContext'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import './TabsContent.scss'

const TabsContent = ({ data, title }) => {
  const { theme } = useTheme()

  function CustomToggle({ children, eventKey }) {
    const [activeStates, setActiveState] = useState(false)
    
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setActiveState(!activeStates)
    })

    let classActive = activeStates ? 'active' : ''
    
    return (
      <button
        type="button"
        className={`btn ${classActive}`}
        onClick={decoratedOnClick}
      >
        {children}
        <FontAwesomeIcon icon={['fas', 'chevron-down']} size="sm" />
      </button>
    )
  }

  const tabs = data?.map((item) => (
    <Tab eventKey={item.id} title={item.title} key={item.id}>
      <ReactMarkdown
        renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
        rehypePlugins={false}
        children={item.content}
        className="markdown-format-title"
      />

      <Accordion defaultActiveKey="0">
        {item?.itemsAccordion?.map((accordion) => (
          <Card key={accordion.id} className={`${theme === 'dark' ? "tabDark" : ""}`}>
            <Card.Header>
              <CustomToggle eventKey={accordion.id}>
                <p className="mb-0 text-left">{accordion.title}</p>
              </CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={accordion.id} >
              <Card.Body>
                <ReactMarkdown
                  renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                  rehypePlugins={false}
                  children={accordion.content}
                  className="markdown-format-content"
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </Tab>
  ))

  return (
    <div className="container tabs-component my-5">
      <h2 className="tabs-title text-uppercase">
        {title}
      </h2>
      <div className="py-4">
        <Tabs defaultActiveKey={data[0].id} id="uncontrolled-tab-example">
          {tabs}
        </Tabs>
      </div>
    </div>
  )
}

export default TabsContent

TabsContent.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.object,
  eventKey: PropTypes.number
}
